var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteRedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2945_9737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.94434 5.1875L2.77462 15.2105C2.83412 15.9333 3.4498 16.5 4.17537 16.5H11.8255C12.5511 16.5 13.1668 15.9333 13.2263 15.2105L14.0565 5.1875H1.94434ZM5.65624 14.625C5.41087 14.625 5.20443 14.4341 5.18887 14.1855L4.72012 6.62303C4.70409 6.36441 4.90046 6.14194 5.15865 6.12591C5.42643 6.10713 5.6393 6.30581 5.65577 6.56444L6.12452 14.1269C6.14112 14.3948 5.92921 14.625 5.65624 14.625ZM8.46918 14.1562C8.46918 14.4153 8.25952 14.625 8.00043 14.625C7.74134 14.625 7.53168 14.4153 7.53168 14.1562V6.59375C7.53168 6.33466 7.74134 6.125 8.00043 6.125C8.25952 6.125 8.46918 6.33466 8.46918 6.59375V14.1562ZM11.2807 6.62306L10.812 14.1856C10.7966 14.4316 10.5915 14.6367 10.3149 14.6241C10.0567 14.6081 9.8603 14.3856 9.87634 14.127L10.3451 6.56447C10.3611 6.30584 10.5877 6.11769 10.8422 6.12594C11.1004 6.14197 11.2968 6.36444 11.2807 6.62306Z",
    fill: "#FC5050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0938 2.375H11.2812V1.90625C11.2812 1.13081 10.6504 0.5 9.875 0.5H6.125C5.34956 0.5 4.71875 1.13081 4.71875 1.90625V2.375H1.90625C1.38847 2.375 0.96875 2.79472 0.96875 3.3125C0.96875 3.83022 1.38847 4.25 1.90625 4.25C6.21769 4.25 9.78247 4.25 14.0938 4.25C14.6115 4.25 15.0312 3.83022 15.0312 3.3125C15.0312 2.79472 14.6115 2.375 14.0938 2.375ZM10.3438 2.375H5.65625V1.90625C5.65625 1.64762 5.86637 1.4375 6.125 1.4375H9.875C10.1336 1.4375 10.3438 1.64762 10.3438 1.90625V2.375Z",
    fill: "#FC5050"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2945_9737"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteRedIcon);
export default __webpack_public_path__ + "static/media/deleteRed-icon.2d33462c.svg";
export { ForwardRef as ReactComponent };